import { EGraphQLFetchPolicy } from '@lib-shared/graphql/graphql-fetch-policy';
import { AttachmentMutations } from '../graphql/attachment.mutations';
import { AttachmentQueries } from '../graphql/attachment.queries';
import { apolloClient } from '@signing-page/apollo';

export class AttachmentService {
  static async getUploadLink(
    attachmentId: string,
    fileExtension: string
  ): Promise<{ url: string; headers: string }> {
    const {
      data: { uploadAttachmentLink },
    } = await apolloClient.query({
      query: AttachmentQueries.getUploadLink,
      fetchPolicy: EGraphQLFetchPolicy.NoCache,
      variables: {
        attachmentId,
        fileExtension: fileExtension.toLowerCase(),
      },
    });
    return uploadAttachmentLink;
  }

  static async upload(
    file: File,
    uploadLink: string,
    headers: Record<string, string>
  ): Promise<void> {
    const body = new FormData();
    Object.keys(headers).forEach((key: string) => body.append(key, headers[key]));
    body.append('file', file);

    return new Promise((res, rej) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', uploadLink, true);
      xhr.send(body);
      xhr.onload = function () {
        this.status === 204 ? res() : rej(this.responseText);
      };
    });
  }

  static async uploadDone(attachmentId: string, fileName: string): Promise<void> {
    const {
      data: { uploadAttachmentLink },
    } = await apolloClient.query({
      query: AttachmentMutations.uploadDone,
      fetchPolicy: EGraphQLFetchPolicy.NoCache,
      variables: {
        attachmentId,
        filename: fileName.toLowerCase(),
      },
    });
    return uploadAttachmentLink;
  }
}
